module.exports = __webpack_public_path__ + "img/img-69fa16.jpg";